import { createFileRoute, useParams } from '@tanstack/react-router';

import { LocationEditScreen } from '@/features/locations/components/workspace/LocationEditScreen';
import { requirePermission } from '@/lib/guards';

export const Route = createFileRoute(
  '/_staff/admin/workspace/organizations/$orgId/locations/$locId/edit',
)({
  beforeLoad: () => {
    requirePermission('location:update');
  },
  component: WorkspaceLocationEditRoute,
  staticData: { crumb: 'Edit' },
});

function WorkspaceLocationEditRoute() {
  const { orgId, locId } = useParams({
    from: '/_staff/admin/workspace/organizations/$orgId/locations/$locId/edit',
  });
  return <LocationEditScreen orgId={orgId} locId={locId} />;
}
